import { render, staticRenderFns } from "./DashboardCashier.vue?vue&type=template&id=5870a427&"
import script from "./DashboardCashier.vue?vue&type=script&lang=js&"
export * from "./DashboardCashier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports